@if (skogsvardForyngring?.length > 0) {
  <div class="row mt-4 ms-0">
    <div class="col-9">
      <rask-list [data]="skogsvardForyngring">
        <rask-list-column header="Trädslag" field="tradslag" width="25%" [nowrap]="true" [sortable]="false">
          <ng-template let-row="row">
            {{row.tradslag}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Frön (kg)" field="malFrogiva" width="25%" [sortable]="false">
          <ng-template let-row="row">
            {{row.malFrogiva}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Antal hektar" field="antalHa" width="25%" [sortable]="false">
          <ng-template let-row="row">
            {{row.antalHa}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Antal frön (kg/ha)" field="frogiva" width="25%" [sortable]="false">
          <ng-template let-row="row">
            {{row.frogiva}}
          </ng-template>
        </rask-list-column>
      </rask-list>
    </div>
  </div>
}
